import { Injectable } from "@angular/core";
import { InputNumber, SelectOption } from "../model/common-type";
// 控件列表
export class FormLine {
  type: FormLineType; // 控件类型
  label: string; // 文本
  name: string; // 字段名称
  placeholder?: string; // 输入框的提示文件
  require?: boolean = false; // 是否必填
  hide?: boolean = false; // 是否为隐藏字段，仅用于填充表单的字段，不显示在页面上
  hideViewDomValue?: boolean = false; // type为ViewDom时，是否隐藏value值, 用于特殊场景，譬如列表中图片的显示
  /** 列设置可见性（仅非 hide 的 ViewDom 可由设置列切换；默认 true） */
  isShow?: boolean = true;
  align?: "left" | "right" | "center"; // 列对齐方式
  value?: string | boolean | number | Date | Array<string | Date> | null = null; // 值 不传默认为null
  isSelect?: boolean; // 输入框等是否允许点击之后全选内容
  selectOption?: SelectOption; // 控件为Select时，选项列表
  explainOptionRight?: ExplainOption; // 明细字段的说明(右侧)
  explainOption?: ExplainOption; // 明细字段的说明
  colorOption?: ColorOption; // 颜色字段的说明
  // 组件内部成员
  maxLength?: number; // input控件的输入长度
  preserveNumber?: number; // 需要保留小数的列的位数
  inputNumber?: InputNumber = new InputNumber(); // number组件的min、max、step
  onChangeEvent?: Function; // 控件的值改变事件 可用于控件间联动
  onSearchEvent?: Function; // select选择器搜索事件 可用于更新备选集合
  onOpenChangeEvent?: Function; // select下拉展开/收起，回调 (open, line)；展开时组件先清空 selectList/selectListName 再回调
  defaultLabel?: any; // select选择器不初始化的时候可以使用defaultLabel搭配value，设置默认值
  hdDisabledDate?: Function; // date-picker组件不可选择的日期
  hdShowToday?: boolean = true; // 对应 nzShowToday，是否显示「今天」按钮，默认 true
  disabled?: boolean; // 不可输入状态
  showTime?: boolean = false; // 日期选择器是否包含时间
  style?: object;
  canSearch?: boolean = false; // 指明hide 情况下的控件是否可以被搜索，默认false
  onChangeEventDebounceTime?: number; // change事件防抖，未配置或为0时同步触发（不防抖）
  onSearchEventEventDebounceTime?: number; // search事件防抖，未配置或为0时同步触发（不防抖）
  onOpenChangeEventDebounceTime?: number; // 下拉展开事件防抖，未配置或为0时同步触发（不防抖）
}

export class ColorOption {
  name: string;
  color?: string;
}

export class ExplainOption {
  show: boolean;
  name: string;
  color?: string;
}

// 控件类型
export enum FormLineType {
  Input = "Input", // 输入框
  Select = "Select", // 单项选择器
  Date = "Date", // 单个日期选择
  DateRange = "DateRange", // 日期范围选择
  TextArea = "TextArea", // 块级输入框
  InputNumber = "InputNumber", // 数字输入
  MultipleSelect = "MultipleSelect", // 多选
  ViewDom = "ViewDom", // 单纯的显示控件
  Switch = "Switch", // 开关
  Time = "Time", // 时间选择器
}

/** 列设置缓存（IndexedDB），仅存可见 ViewDom 的 name 列表 */
export class FormLinesCacheOption {
  cols: Array<string> = [];
}

@Injectable({
  providedIn: "root",
})
export class HdFormLinesService {
  constructor() {}
}
